import { State } from 'src/types'
import { edgeOfCommon } from '../edge'
import { hamidashiOfMiddleFingerBeltBackStyle } from '../hamidashi'
import { ringMiddleLeftFinger, littleFinger } from '../littleRingFinger'
import { thumbFingerOfBeltBackStyle } from '../thumbFinger'
import { beltTypeDrawer } from './beltTypeDrawer'
import { beltBand } from '../beltBand'
import { indexAndMiddleRightFingerOfBeltBackStyle } from '../indexFinger'

export const beltStyleDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  const stitchColor = state.stitch.color

  // 小指側の指袋
  littleFinger(ctx, state.little.color, stitchColor)
  // 薬指・中指左の指袋
  ringMiddleLeftFinger(ctx, state?.middleLeftRing?.color, stitchColor)
  // 人差し指、中指右の指袋
  indexAndMiddleRightFingerOfBeltBackStyle(ctx, state?.indexMiddleRight.color, stitchColor)
  // 親指側の指袋
  thumbFingerOfBeltBackStyle(ctx, state?.thumb?.color, stitchColor)
  // バンド
  beltBand(ctx, state.listBelt.color, stitchColor)
  // ベルトスタイルのハミダシ
  hamidashiOfMiddleFingerBeltBackStyle(ctx, state.hamidashi)
  // ヘリ革
  edgeOfCommon(ctx, state.edge.color)
  // ベルトタイプ別の描画
  beltTypeDrawer(ctx, state)
}
